document.addEventListener('alpine:init', () => {
  Alpine.data('priceRange', (settings) => {
    return {
      minprice: settings.minprice,
      maxprice: settings.maxprice,
      min: settings.min,
      max: settings.max,
      minthumb: 0,
      maxthumb: 0,
      mintrigger() {
        this.validation();
        this.minprice = Math.min(this.minprice, this.maxprice - 1);
        this.minthumb = ((this.minprice - this.min) / (this.max - this.min)) * 100;
      },
      maxtrigger() {
        this.validation();
        this.maxprice = Math.max(this.maxprice, this.minprice + 1);
        this.maxthumb = 100 - (((this.maxprice - this.min) / (this.max - this.min)) * 100);
      },
      validation() {
        if (/^\d*$/.test(this.minprice)) {
          if (this.minprice > this.max) {
            this.minprice = this.max - 1;
          }
          if (this.minprice < this.min) {
            this.minprice = this.min;
          }
        } else {
          this.minprice = 0;
        }
        if (/^\d*$/.test(this.maxprice)) {
          if (this.maxprice > this.max) {
            this.maxprice = this.max;
          }
          if (this.maxprice < this.min) {
            this.maxprice = this.min + 1;
          }
        } else {
          this.maxprice = this.max;
        }
      },
    };
  });
});